export type Handler = (...args: any) => boolean | Promise<boolean>;

export const tryHandlersInOrder = async <T extends Handler>(
  handlers: T[],
  data?: Parameters<T>[0]
) => {
  for (const handler of handlers) {
    if (await handler(data)) {
      return true;
    }
  }
  return false;
};
